const resources = {
  en: {
    translation: {
      initializing: "... Initializing ...",
      loading: "... Loading ...",
      apply: "Apply",
      selectUnit: "Select unit",
      noData: "No data"
    }
  },
  lo: {
    translation: {
      initializing: "... Initializing ...",
      loading: "... Loading ...",
      apply: "Apply",
      selectUnit: "ເລືອກຫົວ​ໜ່ວຍ​ການ​ຈັດ​ຕັ້ງ",
      noData: "No data",
      lo: "ພາສາລາວ"
    }
  },
  vi: {
    translation: {
      initializing: "Đang khởi chạy",
      loading: "Đang tải dữ liệu",
      apply: "Áp dụng",
      noData: "Không có dữ liệu"
    }
  }
};
export default resources;
